import React from "react";
import {
  createFreeDay,
  fetchFreeDaysByDateRangeAndPartnerId,
} from "../../../../services/freeDay.service.ts";
import { weekDays, weeks } from "../../../../utils/constanst";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../store/index.ts";
import { updateOrAddFreeDay } from "../../../../store/slices/scheduleSlice.ts";

const ModalFreeDays = ({
  partnerId,
  setShowModal,
  weekSelected,
}: {
  partnerId: number;
  setShowModal: (_: boolean) => void;
  weekSelected: number;
}) => {
  const dispatch = useDispatch();
  const { freeDays } = useSelector((state: RootState) => state.schedule);
  const [selectedDay, setSelectedDay] = React.useState<number | null>(null);
  const [loading, setLoading] = React.useState(true);

  const fechtFreeDay = async () => {
    try {
      const freeDayFromStore = freeDays.find((fd) => fd.id === partnerId);
      if (
        freeDayFromStore &&
        freeDayFromStore.freeDays &&
        freeDayFromStore.freeDays.length > 0
      ) {
        setSelectedDay(freeDayFromStore.freeDays[0]);
        setLoading(false);
        return;
      }

      const freeDaysData = await fetchFreeDaysByDateRangeAndPartnerId(
        weeks[weekSelected]?.value,
        partnerId
      );
      if (
        freeDaysData?.days &&
        Array.isArray(freeDaysData.days) &&
        freeDaysData.days.length > 0
      ) {
        const index = weekDays.findIndex(
          (d) => d.name === freeDaysData.days[0]
        );

        if (index === -1) {
          throw new Error(`Día no válido: ${freeDaysData.days[0]}`);
        }

        setSelectedDay(index);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const saveFreeDays = async () => {
    setLoading(true);
    try {
      if (selectedDay === null) {
        setLoading(false);
        setShowModal(false);
        return;
      }

      const object = {
        partnerId: partnerId,
        days: [weekDays[selectedDay].name],
        dateRange: weeks.find((w) => w.id === weekSelected)?.value,
      };

      await createFreeDay(object);

      dispatch(
        updateOrAddFreeDay({
          id: partnerId,
          freeDays: [weekDays[selectedDay].id],
        })
      );
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
      setShowModal(false);
    }
  };

  React.useEffect(() => {
    fechtFreeDay();
  }, [partnerId]);

  return (
    <React.Fragment>
      <div className="d-flex w-100 my-3 col-md-12">
        <label className={`form-label col-form-label col-md-3 text-end pe-4`}>
          Días *
        </label>
        <div className="col-9 d-flex flex-row">
          {weekDays.map((day, index) => (
            <button
              key={index}
              type="button"
              onClick={() => {
                const isSelected = selectedDay === index;
                setSelectedDay(isSelected ? null : index);
              }}
              className={`btn ${
                selectedDay === index ? "btn-primary" : "btn-outline-secondary"
              } rounded-pill mx-1`}
              title={day.name}
              style={{
                width: "30px",
                height: "30px",
                textTransform: "capitalize",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {day.name.slice(0, 1)}
            </button>
          ))}
        </div>
      </div>
      <div className="d-flex flex-row mt-5">
        <button
          className="btn btn-secondary ms-auto me-2"
          onClick={() => setShowModal(false)}
        >
          Cancelar
        </button>
        <button
          className="btn btn-primary"
          onClick={() => saveFreeDays()}
          disabled={loading}
        >
          Guardar
        </button>
      </div>
    </React.Fragment>
  );
};

export default ModalFreeDays;
